/* eslint-disable react-hooks/exhaustive-deps */

import React, { ReactElement, useEffect, useState } from 'react';

import { Container, Grid, GridItem, Spinner } from '@constellation/core';
import { useContent } from '@interstellar/react-app-content';
import { useNavigate, useSearchParams } from '@interstellar/react-app-routing';
import SmsNeedHelp from 'components/smsNeedHelp/SmsNeedHelp';
import PageHeading from 'components/pageHeading/PageHeading';
import StyledBox from 'components/style/styledBox/StyledBox';

import { SmsOtpAuthoriseContent } from './SmsOtpAuthoriseContent';
import { fetchAccessTokenDetails } from '../../api';
import { setAccessToken, setRefreshToken } from '../../api/services';
import { StyledGrid } from '../smsOtp/SmsOtp.styled';
import { getRedirectURI } from '../../utils/configUtils';

function SmsOtpAuthorise(): ReactElement {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { smsOtpAuthoriseContent } = useContent<SmsOtpAuthoriseContent>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [
    {
      serviceName,
      technicalErrorPath,
      loaderMessage,
      idvPath,
      submitRegistrationPath,
    },
  ] = smsOtpAuthoriseContent;

  const fnGetAccessToken = async (): Promise<void> => {
    setIsLoading(true);
    const body = {
      AuthorizationCode: searchParams.get('authCode'),
      RedirectUri: getRedirectURI(),
      State: localStorage.getItem('State'),
      CodeVerifier: localStorage.getItem('CodeVerifier'),
    };

    try {
      const res = await fetchAccessTokenDetails(body);
      setIsLoading(false);
      if (res.status === 200) {
        setAccessToken(res.data.AccessToken);
        setRefreshToken(res.data.RefreshToken);
        navigate(idvPath);
      }
    } catch (err) {
      console.log('err: ', err);
      navigate(technicalErrorPath);
    }
  };

  useEffect(() => {
    fnGetAccessToken();
  }, [fnGetAccessToken]);

  return (
    <Container padding="none">
      <PageHeading serviceName={serviceName} />
      <Grid alignX="center" alignY="top">
        <GridItem lg={8}>
          <StyledBox>
            <StyledGrid alignX="center" alignY="center">
              <GridItem>
                <div id="main" data-testid="sca-auth-cwa-main">
                  {isLoading && <Spinner message={loaderMessage} />}
                </div>
              </GridItem>
            </StyledGrid>
          </StyledBox>
        </GridItem>

        <GridItem lg={4}>
          <SmsNeedHelp />
        </GridItem>
      </Grid>
    </Container>
  );
}

export default SmsOtpAuthorise;
